import { render } from "./imageModal.vue?vue&type=template&id=1a4f3210"
import script from "./imageModal.vue?vue&type=script&lang=js"
export * from "./imageModal.vue?vue&type=script&lang=js"
script.render = render

export default script